import emailjs from '@emailjs/browser';

const useSendEmail = () => {

    const sendEmail = (setIsDisabled, emailParams) => {
        if (setIsDisabled === undefined) {
            console.log('Please set the setIsDisabled function');
            return;
        }

        emailjs.send('service_gmail', 'template_contact', emailParams, 'D7rJ8U8SDlsiqkfPe')
            .then(function (response) {
                console.log('SUCCESS!', response.status, response.text);
                setIsDisabled(false);
            }, function (error) {
                console.log('FAILED...', error);
                setIsDisabled(false);
            });
    }

    return [sendEmail]
}

export default useSendEmail